// Chakra imports
import {
  Box,
  VStack,
  HStack,
  Button,
  Circle,
  Icon,
  Text
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import {FiHash,FiHome} from "react-icons/fi";
import React from "react";

export default function VirtualAccountInfo(props) {
  const {user,wallet,createVirtualAccount } = props;
  return (
        <>
        {user!==null && user.kycStatus==="completed" && wallet.chainId!==null && <VirtualAccount wallet={wallet} user={user} />}
        {user!==null && user.kycStatus==="completed" && wallet.chainId===null && <GetVirtualAccount user={user} createVirtualAccount={createVirtualAccount} />}
       </>
  );
}

const VirtualAccount = (props) => {
  const {user,wallet} = props
  return (
          <Card shadow="md" background="blue">
          <VStack>
            <Box textAlign='start' width="100%">
            <Text
              color="white"
              fontSize={{base:'xs',sm:'sm',md:'md',lg:'lg'}}
              my={{ base: "auto", "2xl": "10px" }}
              textAlign='start'>
              Hi
            </Text>
            <Text
              color="white"
              fontWeight="bold"
              fontSize={{base:'md',sm:'md',md:'lg',lg:'xl'}}
              my={{ base: "auto", "2xl": "10px" }}
              textAlign='start'>
              {user.firstName} {user.lastName}
            </Text>
            <Text as="h3"
                color="white"
                textAlign='start'
                fontSize={{base:'2xl',sm:'2xl',md:'2xl',lg:'2xl'}}
                mt={{ base: "5px", "2xl": "5px" }}>
               Your Virtual Account  <Text as="span" color="#61E8E1">Details</Text>
            </Text>
            </Box>
            <Box width="100%">
                <HStack columns="2">
                   <Box width="15%">
                   <Circle size='40px' bg='white' color='white'>
                     <Icon as={FiHome} w='20px' h='20px' color="brand.600" />
                   </Circle>
                   </Box>
                   <Box width="85%">
                    <Text fontSize={{base:'sm',sm:'sm',md:'md',lg:'lg'}} color="white">{wallet.chainName}</Text>
                   </Box>
                </HStack>
                <HStack columns="2" mt="2">
                   <Box width="15%">
                    <Circle size='40px' bg='white' color='white'>
                      <Icon as={FiHash} w='20px' h='20px' color="brand.600" />
                    </Circle>
                   </Box>
                   <Box width="85%">
                    <Text fontSize={{base:'sm',sm:'sm',md:'md',lg:'lg'}} color="white">{wallet.account}</Text>
                   </Box>
                </HStack>
            </Box>
   
          </VStack>
        </Card>
  );
}


const GetVirtualAccount = (props) => {
  const {user,createVirtualAccount} = props
  return (
          <Card shadow="md" background="blue">
          <VStack>
            <Box textAlign='start'>
            <Text
              color="white"
              fontSize={{base:'xs',sm:'sm',md:'md',lg:'lg'}}
              my={{ base: "auto", "2xl": "10px" }}
              textAlign='start'>
              Hi
            </Text>
            <Text
              color="white"
              fontSize={{base:'xs',sm:'sm',md:'md',lg:'lg'}}
              my={{ base: "auto", "2xl": "10px" }}
              textAlign='start'>
              {user.firstName} {user.lastName}
            </Text>
            <Text as="h3"
                color="white"
                textAlign='start'
                fontSize={{base:'sm',sm:'md',md:'lg',lg:'xl'}}
                mt={{ base: "5px", "2xl": "5px" }}>
                You are set to get your <Text as="span" color="orange.600">Virtual Acccount</Text> issued, please click on the Proceed button below to continue
            </Text>
            </Box>
            <Box width="100%">
            <Button mt="5" colorScheme='white' background="#fff" color="#000" variant='solid' onClick={createVirtualAccount}>
              Proceed
            </Button>
            </Box>
          </VStack>
        </Card>
  );
};



